// TeamOverviewGrid — responsive grid of clickable team cards (PRODOPSAI-530).
// Each card is wrapped in a native button so the whole card opens the Team
// Detail view (the card itself stays presentational; S6847-safe).

import type { ITeamMembershipTreeTeam } from '@skystone/shared';
import { TeamCard } from './TeamCard';

interface TeamOverviewGridProps {
  teams: ITeamMembershipTreeTeam[];
  onSelectTeam: (teamId: string) => void;
}

export function TeamOverviewGrid({ teams, onSelectTeam }: Readonly<TeamOverviewGridProps>) {
  return (
    <div
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      data-testid="team-grid"
    >
      {teams.map((team) => (
        <button
          key={team.team.id}
          type="button"
          onClick={() => onSelectTeam(team.team.id)}
          className="rounded-xl text-left transition-all duration-150 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          aria-label={`View ${team.team.name} team detail`}
        >
          <TeamCard team={team} />
        </button>
      ))}
    </div>
  );
}
